import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CreditCard, DollarSign, TrendingUp, Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { KPICard, DataTable, formatCurrency } from '../reportShared';

export default function PolicyBalanceTab({ policyBalance }) {
  return (
    <div className="space-y-6" data-testid="reports-policy-balance-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPICard title="Total Policies" value={policyBalance.length} icon={CreditCard} color="blue" />
        <KPICard
          title="Total Allotment"
          value={formatCurrency(policyBalance.reduce((s, p) => s + p.total_allotment, 0))}
          icon={DollarSign}
          color="green"
        />
        <KPICard
          title="Total Remaining"
          value={formatCurrency(policyBalance.reduce((s, p) => s + p.remaining_balance, 0))}
          icon={TrendingUp}
          color="emerald"
        />
        <KPICard
          title="Avg Utilization"
          value={`${(policyBalance.reduce((s, p) => s + p.utilization_pct, 0) / (policyBalance.length || 1)).toFixed(1)}%`}
          icon={Calendar}
          color="amber"
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Policy Utilization Distribution</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={policyBalance.slice(0, 15)}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="family_id" tick={{ fontSize: 10, angle: -45, textAnchor: 'end' }} height={80} />
              <YAxis tick={{ fontSize: 10 }} />
              <Tooltip formatter={(value) => `${value.toFixed(1)}%`} />
              <Bar dataKey="utilization_pct" fill="#0088FE" name="Utilization %" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Policy Balance Details</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            columns={[
              { key: 'family_id', header: 'Family ID' },
              { key: 'principle_member', header: 'Principal Member' },
              { key: 'total_allotment', header: 'Allotment', align: 'right', render: (val) => formatCurrency(val) },
              { key: 'remaining_balance', header: 'Remaining', align: 'right', render: (val) => formatCurrency(val) },
              { key: 'utilization_pct', header: 'Utilized', align: 'right', render: (val) => `${val.toFixed(1)}%` },
              { key: 'claim_count', header: 'Claims', align: 'center' },
              {
                key: 'status',
                header: 'Status',
                render: (val) => <Badge variant={val === 'Active' ? 'success' : 'secondary'}>{val}</Badge>
              }
            ]}
            data={policyBalance}
          />
        </CardContent>
      </Card>
    </div>
  );
}
